import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface ComprovantePdfModalData {
  titulo: string;
  comprovanteBase64: string;
  nomeArquivo?: string;
}

@Component({
  selector: 'app-comprovante-pdf-modal',
  templateUrl: './comprovante-pdf-modal.component.html',
  styleUrls: ['./comprovante-pdf-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule
  ]
})
export class ComprovantePdfModalComponent implements OnInit {
  pdfUrl: SafeResourceUrl | null = null;
  isLoading = true;
  errorMessage: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<ComprovantePdfModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ComprovantePdfModalData,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.loadPdf();
  }

  private loadPdf(): void {
    try {
      if (!this.data.comprovanteBase64) {
        this.errorMessage = 'Comprovante não disponível';
        this.isLoading = false;
        return;
      }

      // Verifica se já tem o prefixo data:application/pdf
      let base64Data = this.data.comprovanteBase64;
      if (!base64Data.startsWith('data:')) {
        base64Data = `data:application/pdf;base64,${base64Data}`;
      }

      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(base64Data);
      this.isLoading = false;
    } catch (error) {
      console.error('Erro ao carregar PDF:', error);
      this.errorMessage = 'Erro ao carregar o comprovante';
      this.isLoading = false;
    }
  }

  downloadPdf(): void {
    if (!this.data.comprovanteBase64) return;

    try {
      let base64Data = this.data.comprovanteBase64;
      if (base64Data.startsWith('data:')) {
        base64Data = base64Data.split(',')[1];
      }

      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = this.data.nomeArquivo || 'comprovante.pdf';
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Erro ao fazer download:', error);
    }
  }

  fechar(): void {
    this.dialogRef.close();
  }
}
